module.exports = __webpack_public_path__ + "static/media/maleIcon.19c80bec.svg";